// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3ME9o","active":"NavigationItem_active__ch1eb"};